import queryString from "query-string";

export const setUnvisitedPlacesNearbybyQueryStringData = () => state => {
  const { coordinates, id, name, radius, since } = queryString.parse(
    location.search,
  );

  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      since,
    },
    unvisitedPlacesNearby: {
      ...state.unvisitedPlacesNearby,
      coordinates: coordinates || state.unvisitedPlacesNearby.coordinates,
      id: id || state.unvisitedPlacesNearby.id,
      name: name || state.unvisitedPlacesNearby.name,
      radius: Number(radius) || state.unvisitedPlacesNearby.radius,
    },
  };
};
